
	<button nz-button  class="w-100" (click)="goToPriceAlert()">
		<span translate="set.price.alert" translate-default="Set Price Alert"></span>
	</button>
